export class EmployeeLocationHistories {
  Id: number;
  EmpCode: number;
  LocationId: number;
  LocationName: string;
  StartDate: Date;
  EndDate: Date;
  CreatedBy: string;
  CreatedDate: Date;
  ModifiedBy: string;
  ModifiedDate: Date;
  JobLocationState: string;
  IsActive: boolean;
  //to display error message for duplicate records in history tab
  hasDuplicateNameError?: boolean;
  duplicateNameMessage?: string;
}
